<template>
    <div @click="close()" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div id="main-box">
                <div class="row d-flex flex-row-reverse" style="">
                    <div class="col-lg-4 col-md-6 col-sm-8" id="notification">
                        <div class="header notification-item" style="border-bottom: 1px solid rgba(178,178,178,0.5);">
                            <span class="notification-header-icon" @click="close()">&times;</span>
                            <span class="notification-header-text">
                                    اعلانات
                                </span>
                        </div>
                        <div class="body notification-item">
                            <ul>
                                <li v-for="(message,index) in messages"
                                    v-bind:class="{ final : index === messages.length }" :key="message">
                                    <a class="notification-title" :href="direction(message.group_name)" target="_blank">
                                        <div class="notification-title-box">
                                            <img width="24" height="24"
                                                 src="../assets/appIcons/Pics/CanadaAzIran/Icon/CautionGray.png" alt="">
                                            {{message.related_admin.name}}
                                            <br>
                                            <span v-if="message.group_name"
                                                  style="color: rgb(204, 23, 29);display: inline;margin: 0 30px 0 0;padding: 0;font-size: 12px;">
                                                از طرف
                                                {{message.group_name}}
                                            </span>
                                        </div>
                                        <div class="notification-title-box">
                                            {{message.created_at}}
                                        </div>
                                    </a>
                                    <div class="notification-body">
                                        <span v-if="message.text">
                                            {{message.text}}
                                        </span>
                                        <span v-else>
                                            <a :href="$store.state.base_urls.messagesUploads + message.file_name"
                                               target="_blank">
                                                محتوای فایلی:
                                                {{message.file_type}}
                                            </a>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Notification",
        props: {
            messages: Object
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            direction(check_type){
                if(check_type){
                    return '/user-panel/conversation-with-experts/group-messaging';
                }else{
                    return '/user-panel/conversation-with-experts/chatting';
                }
            }
        },

    }
</script>
<style lang="scss" scoped>
    .final {
        border-bottom: none;
        padding-bottom: 0
    }

    .notification-body {
        width: 100%;
        height: auto;
        text-align: justify;
        margin: 10px 0 20px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
    }

    .notification-title {
        display: flex;
        width: 100%;
        cursor: pointer;
    }

    .notification-title-box:nth-child(2) {
        text-align: left;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
    }

    .notification-title-box:nth-child(1) {
        text-align: right;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
    }

    .notification-title-box {
        display: inline-block;
        width: 50%;
    }

    .body {
        ul {
            list-style-type: none;
            padding: 0;

            li {
                width: 100%;
                min-height: 128px;
                height: auto;
                padding: 20px;
                /*background-color: brown;*/
                border-bottom: 1px solid rgba(178, 178, 178, 0.5);
            }
        }
    }


    .notification-header-icon {
        cursor: pointer;
        width: 24px;
        height: 24px;
        object-fit: contain;
        color: #1a1a1a;
    }

    .notification-header-icon {
        float: left;
    }

    .notification-header-text {
        font-family: IRANSans;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #1a1a1a;
    }

    .header {
        width: 100% !important;
        height: 64px !important;
        line-height: 64px !important;
        /*background-color: #4285f4;*/
    }

    .notification-item {
        width: 100%;
        height: auto;
        /*margin: 10px 0;*/
        line-height: 20px;
        color: white;
        font-weight: bold;
        font-size: 2em;
        text-align: center;
    }

    #notification {
        margin: 0;
        padding: 0 30px 0 15px;
        border-radius: 10px;
        min-height: 200px;
        width: 505px;
        height: auto;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        box-shadow: -5px 0 10px 0 rgba(22, 35, 54, 0.2);
        background-color: rgba(255, 255, 255, 0.9);
    }

    #main-box {
        text-align: right;

        .row {
            justify-content: flex-end;
        }
    }

    .modal {
        z-index: 100000000000;
        display: flex; /* Hidden by default */
        position: fixed; /* Stay in place */
        right: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    .modal-content {
        overflow-x: hidden;
        text-align: right;
        float: right;
        position: relative;
        top: 0;
        height: 100%;
        background-color: unset !important;;
        margin: auto;
        padding: 0;
        border: unset !important;
        box-shadow: unset !important;
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    @-webkit-keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }

    @keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }

    button:hover {
        background-color: #fe7063;
        border: none;
    }

    button {
        width: 280px;
        height: 50px;
        border-radius: 5px;
        background-color: #162336;
        padding: 11px 41px;
        font-size: 16px;
        margin: auto;
    }
</style>